;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('linkedinPreview', linkedinPreview)

  function linkedinPreview () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        thumbnail: '<',
        data: '<'
      },
      templateUrl: '/arts/directives/linkedin-preview/linkedin-preview-directive.html?$$REVISION$$'
    }
  }
})()
